/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AuthSupport } from '../../models/auth-support';

export interface GetAuthSupportVnf$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;
}

export function getAuthSupportVnf(http: HttpClient, rootUrl: string, params: GetAuthSupportVnf$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthSupport>> {
  const rb = new RequestBuilder(rootUrl, getAuthSupportVnf.PATH, 'get');
  if (params) {
    rb.path('uid', params.uid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AuthSupport>;
    })
  );
}

getAuthSupportVnf.PATH = '/custom/auth-supports/{uid}';
